import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {login} from 'actions/connect';

class LockScreen extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'LockScreen';
        this.handleUnlock = this.handleUnlock.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.state = {
        	password : undefined,
        	username : undefined,//this.props.connection.user.username,
        	error : null,
        }
    }
    componentWillMount() {
    	setTimeout(() => {
	    	if(!this.props.connection.user || !this.props.connection.user._id)
	    		window.location = "/signin";
    	}, 5000);
    }
    handlePasswordChange(event) {
    	var p = event.target.value;
    	this.setState({ password : p });
    }
    handleUnlock(event) {
    	event.preventDefault();
    	this.setState({error:null}, () =>
	    	this.props.dispatch(login(
	    	{
	    		username : this.props.connection.user.username,
	    		password: this.state.password
	    	},
	    	(error) => {
	    		this.setState({error})
	    	}
		)));
    }
    render() {
    	var username = this.props.connection.user.username;
    	var email = this.props.connection.user.email;//this.props.connection.user.email;
    	var name = {first : '', last : ''};

    	if(typeof this.props.connection.user.name !== 'undefined')
    		name = this.props.connection.user.name;

        return (

        	<section id="LockScreenInline" className="body-sign body-locked body-locked-inline">
				<div className="center-sign">
					<div className="panel panel-sign">
						<div className="panel-body">
							<form>
								<div className="current-user text-center">
									<h2 id="LockUserName" className="user-name text-dark m-none">{username}</h2>
									<p  id="LockUserEmail" className="user-email m-none">{email}</p>
								</div>
								<div className="form-group mb-lg">
									<div className="input-group input-group-icon">
										<input id="pwd" name="pwd" type="password" onChange={this.handlePasswordChange} value={this.state.password} className="form-control input-lg" placeholder="Password" />
										<span className="input-group-addon">
											<span className="icon icon-lg">
												<i className="fa fa-lock"></i>
											</span>
										</span>
									</div>
								</div>
								{(()=>{
									if(this.state.error) {

										return (
											<div className="row">
												<div className="col-xs-12">
													<div className="alert alert-danger">
														<p>{this.state.error.message}</p>
													</div>
												</div>
											</div>
											);
									}
								})()}

								<div className="row">
									<div className="col-xs-6">
										<p className="mt-xs mb-none">
											<a href="/signin">Not {name.first + ' ' + name.last}?</a>
										</p>
									</div>
									<div className="col-xs-6 text-right">
										<button type="submit" className="btn btn-primary" onClick={this.handleUnlock}>Unlock</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</section>
        );
    }
}

var mapStateToProps = function(state) {
	return {
		connection : state.connection
	}
}

export default connect(mapStateToProps)(LockScreen);



// WEBPACK FOOTER //
// ./src/browser/components/app/lockScreen.js